<div class='form-group'>
    <mat-slide-toggle 
        [checked]="value"
        [attr.data-cy]='switchKey'
        (change)="toggle($event.checked)">
    </mat-slide-toggle>
    <ng-content></ng-content>
</div>
